import React from "react";
import mig from "../../assets/Home/mig.png";
const About = () => {
  return (
    <div className=" bg-indigo-700 pt-16 flex flex-col gap-3 pb-10 ">
      <div className="mt-2 flex flex-col justify-center items-center gap-1">
        <span className=" py-1 px-2 bg-gradient-to-r from-indigo-500 ... w-1/4 h-auto rounded-lg text-white text-xs mt-2 mx-3">
          Something...
        </span>
        <div className=" bg-pink-600 w-24 h-9 rounded-lg text-white  text-center pt-1  text-lg mx-3 mb-4   ">
          About Me
        </div>
      </div>
      <div className="img-text container flex flex-col gap-3 justify-center items-center">
        <div className="w-72 ml-7 mb- md:w-66 profile bg-gradient-to-r from-indigo-500 rounded-full lg:">
          <img src={mig} alt="" className=" rounded-full " />
        </div>
        <div className="top-1 md:w-2/3 md:top-4  mx-4 py-4 px-4 border-2 border-pink-600 hover:border-white hover:transition h-auto rounded-2xl text-white md:right-1 mb-8 transition ease-in delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-100 hover:bg-indigo-500 duration-300 ">
          <p>
            Okay, this is actually I don't know weird to me? But I'll try to do
            it, my history with web development really started when I was in
            high school, my first work as a coder was to make using HTML a
            periodic table, I'm pretty sure mine was the best. But I don't know
            why then I didn't appreciate my skill with the code.
          </p>
          <br />
          <p>
            A lot of time passed, until the moment when I had the opportunity to
            see what necessary the programming world is, and how worth it is for
            the future. Last year I saw on Facebook an announcement about a
            grant to study full-stack development. I made the application and
            all was great, I was accepted, and I started to learn coding in the
            right way. Now, I've finished my formation and I actually love all
            the things I learned and what know about this amazing world related
            to tech that is only growing all the time.
          </p>
          <br />
          <p>
            At this moment, I'm looking for a job where I could practice and
            improve my skills. I want to show that I can be a being human util
            and that I know how to indicate to a computer how to do a whole
            universe of apps...
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
